module.exports = "/static-assets/_next/static/images/img-e73bf68460-f6d8ab123eacf13b37874b654b0a8b4f.webp";